<template>
  <v-main app>
    <navigationDrawer />
  </v-main>
</template>

<script>
import navigationDrawer from "@/components/navigationDrawer.vue";

export default {
  name: "HomeView",

  components: {
    navigationDrawer,
  },
};
</script>
